"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allotmentColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../utils/roundMoney");
const verify_1 = require("../../../utils/verify");
const Airport_1 = require("../../Flight/List/Cell/Airport");
const Departure_1 = require("../../Flight/List/Cell/Departure");
const idColumn_1 = require("../../Table/columns/idColumn");
const selectColumn_1 = require("../../Table/columns/selectColumn");
const actionsColumn_1 = require("./actionsColumn");
const InvoicedStatus_1 = require("./Cell/InvoicedStatus");
const Tariff_1 = require("./Cell/Tariff");
const allotmentColumns = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ([
        (0, selectColumn_1.selectColumn)({
            hidden: (_a = config.select) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        (0, idColumn_1.idColumn)({
            disableSortBy: true,
            hidden: (_b = config.id) === null || _b === void 0 ? void 0 : _b.hidden,
        }),
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:agent', defaultMessage: 'Agent' })),
            id: 'agent',
            Cell: ({ row }) => { var _a, _b; return (_b = (_a = (0, verify_1.verifyAgent)(row.original.agent)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : null; },
            hidden: (_c = config.agent) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:departure', defaultMessage: 'Departure' })),
            id: 'flightDate',
            Cell: ({ row }) => (react_1.default.createElement(Departure_1.FlightDepartureCell, { flight: (0, verify_1.verifyFlightListItem)(row.original.flight) })),
            canSort: true,
            hidden: (_d = config.departure) === null || _d === void 0 ? void 0 : _d.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:flightNumber', defaultMessage: 'Flight Number' })),
            id: 'flightNumber',
            Cell: ({ row }) => {
                var _a;
                return (_a = row.original.flight) === null || _a === void 0 ? void 0 : _a.number;
            },
            canSort: true,
            hidden: (_e = config.flightNumber) === null || _e === void 0 ? void 0 : _e.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:origin', defaultMessage: 'Origin' })),
            id: 'flightOrigin',
            Cell: ({ row }) => { var _a; return react_1.default.createElement(Airport_1.FlightAirportCell, { airport: (_a = (0, verify_1.verifyFlightListItem)(row.original.flight)) === null || _a === void 0 ? void 0 : _a.origin }); },
            hidden: (_f = config.origin) === null || _f === void 0 ? void 0 : _f.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:destination', defaultMessage: 'Destination' })),
            id: 'flightDestination',
            Cell: ({ row }) => { var _a; return react_1.default.createElement(Airport_1.FlightAirportCell, { airport: (_a = (0, verify_1.verifyFlightListItem)(row.original.flight)) === null || _a === void 0 ? void 0 : _a.destination }); },
            hidden: (_g = config.destination) === null || _g === void 0 ? void 0 : _g.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:tariff', defaultMessage: 'Tariff' })),
            id: 'tariff',
            Cell: ({ row }) => react_1.default.createElement(Tariff_1.AllotmentTariffCell, { tariff: (0, verify_1.verifyTariffGroup)(row.original.tariffGroup) }),
            hidden: (_h = config.tariff) === null || _h === void 0 ? void 0 : _h.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:seatsNumber', defaultMessage: 'Number of Seats' })),
            accessor: 'seatsNumber',
            disableSortBy: true,
            hidden: (_j = config.seatsNumber) === null || _j === void 0 ? void 0 : _j.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:costPerSeat', defaultMessage: 'Price per Seat' })),
            id: 'costPerSeat',
            Cell: ({ row }) => {
                const { locale } = (0, react_intl_1.useIntl)();
                return (react_1.default.createElement("div", null,
                    (0, roundMoney_1.localizeMoney)(row.original.costPerSeat, locale, 'Allotment/List/tableColumns/costPerSeat'),
                    " CHF"));
            },
            hidden: (_k = config.costPerSeat) === null || _k === void 0 ? void 0 : _k.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:total', defaultMessage: 'Total' })),
            id: 'total',
            Cell: ({ row }) => {
                const { total } = row.original;
                const { locale } = (0, react_intl_1.useIntl)();
                return (react_1.default.createElement("div", null,
                    (0, roundMoney_1.localizeMoney)(total, locale, 'Allotment/List/tableColumns/total'),
                    " CHF"));
            },
            hidden: (_l = config.total) === null || _l === void 0 ? void 0 : _l.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Column:status', defaultMessage: 'Status' })),
            id: 'status',
            Cell: ({ row }) => { var _a; return react_1.default.createElement(InvoicedStatus_1.AllotmentInvoicedStatusCell, { invoicedStatus: ((_a = row.original.invoice) === null || _a === void 0 ? void 0 : _a.id) ? 'invoiced' : 'open' }); },
            hidden: (_m = config.total) === null || _m === void 0 ? void 0 : _m.hidden,
        },
        (0, actionsColumn_1.allotmentActionsColumn)(config.actions),
    ]);
};
exports.allotmentColumns = allotmentColumns;
//# sourceMappingURL=tableColumns.js.map